import React from 'react';
import PropTypes from 'prop-types';
import { Paragraph } from 'components/atoms/Text';
import { translate } from 'utils/translate';
import { LinkButton } from 'components/atoms/Button/Button';
import Icon from 'components/atoms/Icon';
import {
  marker,
  phone,
  outlineEnvelope,
  www,
  signpost,
} from 'components/atoms/Icon/icons';
import SocialMediaLinkBlock from 'episerver/blocks/SocialMediaLinkBlock';
import * as styles from './ProductContactInfo.scss';

const IconListItem = ({ icon, children }) => (
  <Paragraph className={styles.iconListItem}>
    <Icon icon={icon} className={styles.iconListIcon} size={['.9em', '.9em']} />
    {children}
  </Paragraph>
);
IconListItem.propTypes = {
  icon: PropTypes.any,
  children: PropTypes.node,
};

const isExternalSystemShown = externalSystem =>
  ['Facebook', 'Twitter', 'Instagram', 'FourSquare'].indexOf(externalSystem) !==
  -1;

const ProductContactInfo = ({
  address,
  contactInfo = {},
  place,
  externalSystemList,
  className,
  onAddressClick,
}) => (
  <div className={className}>
    {!!address &&
      (!!address.street || !!address.postalCode || !!address.postalName) && (
        <IconListItem icon={marker}>
          {onAddressClick ? (
            <LinkButton
              onClick={onAddressClick}
              style={{ verticalAlign: 'middle', display: 'inline-block' }}
            >
              {address.street}
              {!!address.street &&
                (!!address.postalCode || !!address.postalName) && <br />}
              {address.postalCode} {address.postalName}
            </LinkButton>
          ) : (
            <span style={{ verticalAlign: 'middle', display: 'inline-block' }}>
              {address.street}
              {!!address.street &&
                (!!address.postalCode || !!address.postalName) && <br />}
              {address.postalCode} {address.postalName}
            </span>
          )}
        </IconListItem>
      )}
    {
      // TODO readd when SimpleView updated their API to enable localisation
      /* {!!place && (
      <IconListItem icon={signpost}>
        <span>{`${translate('/product/area')}: ${place}`}</span>
      </IconListItem>
    )} */
    }
    {!!contactInfo.telephone && (
      <IconListItem icon={phone}>
        <LinkButton href={`tel:${contactInfo.telephone}`}>
          {contactInfo.telephone}
        </LinkButton>
      </IconListItem>
    )}
    {!!contactInfo.email && (
      <IconListItem icon={outlineEnvelope} className={styles.email}>
        <LinkButton href={`mailto:${contactInfo.email}`} breakWord>
          {translate('/product/sendMail')}
        </LinkButton>
      </IconListItem>
    )}
    {!!contactInfo.website && (
      <IconListItem icon={www}>
        <LinkButton
          href={contactInfo.website}
          breakWord
          target="_blank"
          rel="roopener noreferrer"
        >
          {translate('/product/visitwebsite')}
        </LinkButton>
      </IconListItem>
    )}
    {!!externalSystemList && externalSystemList.length && (
      <div className={styles.socialContainer}>
        {externalSystemList.map(externalSystem => {
          // Fake social media link block-element
          const buttonData = {
            url: { $c: externalSystem.id },
            mediaType: { $c: externalSystem.externalSystem.toLowerCase() },
            invertImage: { $c: true },
          };
          return isExternalSystemShown(externalSystem.externalSystem) ? (
            <SocialMediaLinkBlock
              block={buttonData}
              key={externalSystem.externalSystem}
            />
          ) : null;
        })}
      </div>
    )}
  </div>
);
ProductContactInfo.displayName = 'ProductContactInfo';
ProductContactInfo.propTypes = {
  address: PropTypes.object,
  place: PropTypes.string,
  contactInfo: PropTypes.object,
  externalSystemList: PropTypes.arrayOf(
    PropTypes.shape({
      externalSystem: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    }),
  ),
  className: PropTypes.string,
  onAddressClick: PropTypes.func,
};
ProductContactInfo.defaultProps = {};

export default ProductContactInfo;
